import { Observable, concat, forkJoin, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { ModalService } from 'ui-components/services/modal-service';

import Global from '../../store/global-selectors';
import { VoidLabelModal } from '../../components/modals/void-label-modal';
import * as Actions from './labels.actions';
import * as LabelsApi from './labels.api';

export const launchVoidModal = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_VOID_MODAL),
    mergeMap((action) => {
      const { shouldReconcileShipTo } = action;
      return new Observable((observer) => {
        ModalService.launchModal({
          component: VoidLabelModal,
          props: {
            acceptWarningAndVoid: () => {
              observer.next(Actions.acceptWarningAndVoid(shouldReconcileShipTo));
            },
            retryVoid: () => {
              observer.next(Actions.retryVoid(shouldReconcileShipTo));
            },
          },
          onClose: (isCancel) => {
            observer.next(Actions.onVoidModalClosed({ isCancel }));
            observer.complete();
          },
        });
      }).pipe(
        mergeMap((nextAction) => {
          if (nextAction.type === Actions.RETRY_VOID) {
            const voidWarnings = Global.selectLabelsVoidWarnings(getState());
            const fulfillmentVoidIds = voidWarnings.map((labelCardProps) => labelCardProps.fulfillmentId);
            return concat(of(nextAction), of(Actions.voidLabels(fulfillmentVoidIds, shouldReconcileShipTo)));
          }

          return of(nextAction);
        }),
      );
    }),
  );
};

export const acceptWarningAndVoid = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.ACCEPT_WARNING_AND_VOID),
    mergeMap((action) => {
      const { shouldReconcileShipTo } = action;
      const fulfillments = Global.selectLabelsFulfillments(getState());
      const fulfillmentIds = fulfillments.map((fulfillment) => fulfillment.fulfillmentId);
      return of(Actions.voidLabels(fulfillmentIds, shouldReconcileShipTo));
    }),
  );
};

export const voidLabels = (action$) => {
  return action$.pipe(
    ofType(Actions.VOID_LABELS),
    mergeMap(({ fulfillmentIds, shouldReconcileShipTo }) => {
      const theVoid$ = fulfillmentIds.map((id) => LabelsApi.voidSingleLabel(id, shouldReconcileShipTo));

      return forkJoin(theVoid$).pipe(
        mergeMap((data) => of(Actions.voidLabelsSuccess(data))),
        catchError((err) => of(Actions.voidLabelsFailure(err))),
      );
    }),
  );
};
